import { gql } from '@apollo/client';

export const GET_PERSON = gql`
  query User($personId: Int!) {
    user(personId: $personId) {
      id
      photoUrl
      isBeingViewedByBuddy
      buddies {
          id
          name
          photoUrl
      }
      currentCourseAttendances {
        attendance {
            id
            status
        }
        courseId
        course {
            id
            name
            SKU
        }
      }
      isArchived
      scriptName
      canEditPhone
      haveRegistrationDocument
      registrationDocumentUrl
      preferredName
      identifier
      name
      dob
      address
      attendancePercentage
      truency
      picturePermission
      coursesTeaching {
        id
        name
        SKU
      }
      courses {
        id
        name
        SKU
      }
    }
  }
`;
